// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"e040f6d42b8f321914a0","966":"2207fcc0c3e0ff1941c8"}[chunkId] + ".js";
};